export default __webpack_public_path__ + "static/media/gallery_17.98c9e438.jpg";